import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Box,
  CircularProgress,
  TableCell,
  TableHead,
  TableRow,
  Table,
  TableBody,
  Chip,
  FormControlLabel,
  Checkbox,
  Card,
  InputAdornment,
  Link,
  Tooltip,
  TableContainer,
  Paper,
  Divider,
  Radio,
  Backdrop,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import axios from 'src/utils/axios';
import PersonIcon from '@material-ui/icons/Person'; // Person icon
import LocalMallIcon from '@material-ui/icons/LocalMall'; // Ürün icon
import { getUser, moneyFormat } from 'src/utils/Common';
import { base64Reader, saveFotograf } from 'src/utils/storage/StrPhoto';
import {
  getTasksRequest
} from '../../store/actions';
import { useHistory } from 'react-router';
import { connect, useDispatch, useSelector } from 'react-redux';
import { paymentThunks } from '../../store/slices/paymentSlice';
import paymentSignalRService from '../../signalr/payment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import RepeatOneIcon from '@material-ui/icons/RepeatOne';
import moment from 'moment';
import Alert from 'src/components/Alert';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ThemeProvider } from '@material-ui/styles';
import { createTheme } from '@material-ui/core/styles';
import trLocale from 'date-fns/locale/tr';

const Compress = require('compress.js').default;
const compress = new Compress();

const useStyles = makeStyles((theme) => ({
  stepper: {
    backgroundColor: 'transparent',
  },
  step: {
    '&$completed': {
      color: theme.palette.success.main,
    },
    '& .MuiStepLabel-label': {
      color: 'grey', // Tamamlanmamış adımlar için gri renk
    },
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  completed: {
    '& .MuiStepLabel-label': {
      color: theme.palette.success.main, // Tamamlanmış adımlar için yeşil renk
    },
  },
  activeStep: {
    '& .MuiStepLabel-label': {
      color: theme.palette.primary.main, // Aktif adım için birincil renk
    },
  },
  box: {
    width: '900px',
    border: '1px solid grey',
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
  },
  line: {
    borderBottom: '2px solid grey',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  materialRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    borderBottom: '1px solid grey', // Alt çizgi ekliyoruz
    cursor: 'pointer', // İşaretçi ikonunu değiştir
    '&:hover': {
      backgroundColor: '#f0f0f0', // Hover durumunda arka planı değiştir
    },
    '&.selected': {
      backgroundColor: '#d3d3d3', // Seçildiğinde arka planı gri yap
    },
  },
  selectedMaterialDetails: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid grey',
    borderRadius: theme.spacing(1),
  },
  paymentIframe: {
    width: '100%',
    height: '500px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: theme.shadows[2],
  },
  paymentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '400px',
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: '#4caf50',
    '&$checked': {
      color: '#4caf50',
    },
  },
  checked: {},
})(Checkbox);

const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};

const FormPage = ({ AssetId, handleCloseDialog, consumerId, WarrantyStartDate, getTasksRequest }) => {
  // const { t } = useTranslation('overview');
  const { t } = useTranslation('work_order');
  const classes = useStyles();
  const dispatch = useDispatch();
  const paymentState = useSelector(state => state.payment);
  const [activeStep, setActiveStep] = useState(0);
  const [materials, setMaterials] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [paymentType, setPaymentType] = useState(0);
  const [PaymentDetail, setPaymentDetail] = useState('');
  const [formData, setFormData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const SessionUser = getUser();
  const [activePaymentTypeData, setActivePaymentTypeData] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const history = useHistory();
  const [attachements, setAttachements] = useState({
    name: "",
    file: {},
    MIMEType: "",
    FileData: ""
  });
  const loading = open && optionsBillingConsumer.length === 0;
  const [optionsBillingConsumer, setOptionsBillingConsumer] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [billingConsumer, setBillingConsumer] = useState(0);
  const [consumerAddressId, setconsumerAddressId] = useState(0);
  const [sameAddress, setSameAddress] = useState(true);
  const [searchBillingConsumer, setSearchBillingConsumer] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [consumerAddressDetails, setConsumerAddressDetails] = useState([]);
  const [SKU, setSKU] = useState('');
  const [ProductId, setProductId] = useState('');
  const [ProductYear, setProductYear] = useState('');
  const [ProductMonth, setProductMonth] = useState('');
  const [SerialNumber, setSerialNumber] = useState('');
  const [FirstSerialNumber, setFirstSerialNumber] = useState('');
  const [FirstYear, setFirstYear] = useState('');
  const [FirstMonth, setFirstMonth] = useState('');
  const [Required, setRequired] = React.useState(false);
  const [formState, setFormState] = useState([
    {
      name: 'SerialNumber',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: t('error_serino')
    },
    {
      name: 'ProductYear',
      min: 0,
      max: maxYil,
      valid: true,
      errorMessage: t('error_uyil').replace('@maxYil', maxYil)
    },
    {
      name: 'ProductMonth',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: t('error_udonem')
    }
  ]);
  const search = '';
  const today = new Date();
  const maxYil = today.getFullYear();
  const [SerialParam, setSerialParam] = React.useState('');
  const [loading3, setLoading3] = useState(false);
  const [uyariCiktiNote, setUyariCiktiNote] = useState(false);
  const [uyariAciklamaNote, setUyariAciklamaNote] = useState('');
  const [uyariTipCiktiNote, setUyariTipCiktiNote] = useState();
  const [garantiTarihi, setGarantiTarihi] = React.useState(moment(WarrantyStartDate, 'DD.MM.YYYY').format('YYYY-MM-DD'));
  const locale = localStorage.getItem('i18nextLng');
  const [AssetInformation, setAssetInformation] = React.useState(false);
  const [ProductionYear, setProductionYear] = useState('');
  const [ProductionMonth, setProductionMonth] = useState('');
  const [ParsedSerialNr, setParsedSerialNr] = useState('');
  const [showPaymentIframe, setShowPaymentIframe] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [waitingForPayment, setWaitingForPayment] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const [connectionState, setConnectionState] = useState('Disconnected');
  const [applicationReference, setApplicationReference] = useState('');
  const [paymentSuccessMessage, setPaymentSuccessMessage] = useState('Your payment has been processed successfully.');

  const steps = ['Customer Details', 'Available Materials', 'Product Details', 'Payment Method', 'Order and Payment Confirmation', 'Payment'];

  useEffect(() => {
    fetchGetValuePropositionHeaderByAssetId(AssetId);
    fetchGetConsumerValuePropositionDetailByAssetId(AssetId);
  }, [AssetId]);

  useEffect(() => {
    GetActivePaymentTypes();
  }, []);

  // SignalR connection setup
  useEffect(() => {
    const setupSignalR = async () => {
      try {
        console.log('Setting up SignalR connection...');

        // Set up callbacks
        paymentSignalRService.setCallbacks({
          onPaymentUpdate: (isSuccess, message, paymentData) => {
            console.log('Payment update received:', { isSuccess, message, paymentData });
            if (isSuccess) {
              setPaymentCompleted(true);
              setWaitingForPayment(false);
              setShowPaymentIframe(false);
              // Show success message and navigate
              setTimeout(() => {
                setSaved(true);
                setTimeout(() => {
                  setSaved(false);
                  setActiveStep(0);
                  setSelectedMaterial([]);
                  setPaymentType('');
                  handleCloseDialog();
                }, 3000);
              }, 1000);
            } else {
              setPaymentError(message);
              setWaitingForPayment(false);
            }
          },
          onPaymentError: (errorMessage) => {
            console.error('Payment error:', errorMessage);
            setPaymentError(errorMessage);
            setWaitingForPayment(false);
          },
          onConnectionStateChange: (state, error) => {
            console.log('SignalR connection state changed:', state);
            setConnectionState(state);
            if (error) {
              console.error('SignalR connection error:', error);
            }
          }
        });

        // Initialize connection
        console.log('Initializing SignalR connection...');
        await paymentSignalRService.initializeConnection();
        console.log('SignalR connection initialized successfully');
      } catch (error) {
        console.error('Failed to setup SignalR:', error);
        setConnectionState('Error');
      }
    };

    setupSignalR();

    // Cleanup on unmount
    return () => {
      if (applicationReference) {
        paymentSignalRService.leaveGroup(applicationReference);
      }
      paymentSignalRService.disconnect();
    };
  }, [handleCloseDialog]); // Remove applicationReference from dependencies

  React.useEffect(() => {
    if (searchBillingConsumer && searchBillingConsumer.length > 3) {
      axios
        .get(
          `/BillingConsumerSearch/${searchBillingConsumer.toString()}`
        )
        .then(res => {
          if (res.data.length > 0) {
            // Assuming res.data is an array of objects with a 'Dsc' property
            setOptionsBillingConsumer(res.data);
          } else {
            setOptionsBillingConsumer([]);
          }
        })
        .catch(err => {
          setOptionsBillingConsumer([]);
        });
    }
  }, [searchBillingConsumer]);

  const fetchGetValuePropositionHeaderByAssetId = async (id) => {
    axios
      .get(`/GetValuePropositionHeader/${id}`)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
          setFormData(response.data[0]);
          setSerialParam(response.data[0].SerialNr);
          setSKU(response.data[0].ProductCode);
          setProductId(response.data[0].ProductId);
          setFirstSerialNumber(response.data[0].ParsedSerialNr);
          setProductionYear(response.data[0].ProductionYear);
          setProductionMonth(response.data[0].ProductionMonth);
          setParsedSerialNr(response.data[0].ParsedSerialNr);
          setFirstMonth(response.data[0].ProductionMonth);
          setFirstYear(response.data[0].ProductionYear);
          if (ProductYear == '') {
            setUyariAciklamaNote("Enter and parse serial number to proceed!");
            setUyariTipCiktiNote('info');
            setUyariCiktiNote(true);
          }
        }
      });
  };

  const fetchGetConsumerValuePropositionDetailByAssetId = async (id) => {
    axios
      .get(`/GetConsumerValuePropositionDetail/${id}`)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
          setMaterials(response.data);
        }
      });
  };

  const handleAddressSelect = (address) => {
    setconsumerAddressId(address.ConsumerAddressId);
    setBillingConsumer(address.ConsumerId);
  };

  const [addresses, setAddresses] = useState([]);

  const fetchAddresses = async (consumerId) => {
    try {
      const response = await fetch(`/api/consumer/${consumerId}/addresses`);
      const data = await response.json();
      setAddresses(data); // Gelen adresleri state'e kaydedin
    } catch (error) {
      console.error('Error fetching addresses:', error);
    }
  };

  const handleChangeImage = async (event) => {
    var files = event.target.files[0];
    let base64Result = '';
    if (!window.navigator.onLine) {
      // offline
      let reader = new FileReader();
      reader.onload = function (base64) {
        saveFotograf(
          // ReceiptNo,
          base64.target.result,
          // DosyaTipi,
          files.name,
          files.type
        );
      };
      reader.readAsDataURL(files);
    } else {
      const meta = files?.type;
      if (meta.indexOf('image') !== -1) {
        const resizedImage = await compress.compress([files], {
          size: 0.3, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 1920, // the max width of the output image, defaults to 1920px
          maxHeight: 1920, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        });
        const img = resizedImage[0];
        base64Result = img.data;
      } else {
        base64Result = await base64Reader(files);
      }
    }
    event.persist();
    setAttachements({
      name: files?.name,
      MIMEType: files?.type,
      file: files,
      FileData: base64Result
    });
  };

  const GetConsumerAddressFromConsumer = (consumerId) => {
    setLoading2(true);
    setConsumerAddressDetails([]);
    axios
      .get(`/GetConsumerAddressFromConsumerId/` + consumerId)
      .then(response => {
        setLoading2(false);
        if (response.data.length > 0) {
          setConsumerAddressDetails(response.data);
        }
      })
      .catch(error => {
        setLoading2(false);
      });
  }

  const updateText = data => {
    setBillingConsumer(data);
    GetConsumerAddressFromConsumer(data.Id);
  };

  const setWorkCaseAndContract = async () => {
    const dataBody = {
      AssetId: AssetId || 0,
      ConsumerId: consumerId || 0,
      SKU: formData?.ProductCode,
      SerialNr: SerialParam,
      ParsedSerialNr: ParsedSerialNr,
      ProductionYear: ProductionYear,
      ProductionMonth: ProductionMonth,
      PaymentTypeId: paymentType,
      PaymentDetail: PaymentDetail,
      MaterialId: selectedMaterial.MaterialId,
      EmployeeId: SessionUser.TechnicianId,
      FileName: attachements?.name,
      MIMEType: attachements?.MIMEType,
      FileData: attachements?.FileData,
      WarrantyStartDate: garantiTarihi,
      Price: selectedMaterial?.Price,
      VatRate: selectedMaterial?.VatRate,
      VatId: selectedMaterial?.VatId,
      PriceListEntryId: selectedMaterial?.PricelistEntryId,
      CurrencyId: selectedMaterial?.CurrencyId,
      ConsumerAddressId: consumerAddressId || 0,
      BillingConsumerId: billingConsumer || 0,
      IsAssetInformationChange: AssetInformation
    };
    const dataConfigCancellation = {
      headers: { 'Content-Type': 'application/json' }
    };

    try {
      const response = await axios.post(`/SetWorkCaseAndContractForValueProposition`, dataBody, dataConfigCancellation);
      if (response.data !== "") {
        setFormData(response.data[0]);
        return response.data;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleMaterialSelect = (material) => {
    if (selectedMaterial === material) {
      setSelectedMaterial(null);
    } else {
      setSelectedMaterial(material);
    }
  };

  const GetActivePaymentTypes = () => {
    axios
      .get(`/GetActivePaymentTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setActivePaymentTypeData(response.data);
        }
      })
      .catch(error => { });
  };

  const handleChangePaymentType = event => {
    // let job = SonlandirData[0];
    // job = {
    //   ...job,
    //   PaymentTypeId: event.target.value
    // };
    // setTask(job);
    setPaymentType(event.target.value);
  };

  const handleChangePaymentDetail = event => {
    // let job = SonlandirData[0];
    // job = {
    //   ...job,
    //   PaymentDetail: event.target.value
    // };
    // setTask(job);
    setPaymentDetail(event.target.value);
  };

  const handleSave = async () => {
    // Fetch activated sales types and derive warranty (SalesTypeId=3) availability for this tenant
    let isExtraWarrantySalesActive = false;
    try {
      const resp = await dispatch(paymentThunks.GetSironexActivatedTenants());
      const list = resp?.payload || [];
      isExtraWarrantySalesActive = list.some(x =>
        x.SalesTypeId === 3 &&
        x.TenantId === SessionUser?.TenantId
      );
    } catch (e) {
      console.error('GetSironexActivatedTenants failed', e);
    }
    // (Optional) use or log the variable for now
    console.log('isExtraWarrantySalesActive:', isExtraWarrantySalesActive);

    setSaving(true);
    //@TODO Buraya bir yapı ve logic eklenmesi gerekiyor, şuanki yapı ile olmaz. 
    var paymentTypeName = activePaymentTypeData.find(pt => pt.Id === paymentType)?.Dsc || '';
    if (isExtraWarrantySalesActive && (paymentTypeName === 'Credit Card') || (paymentType === 2 || paymentType === 13)) {
      {
        try {
          // Calculate price with VAT
          const priceWithVat = selectedMaterial.Price * (1 + (selectedMaterial.VatRate / 100));

          // Create application reference
          const appRef = `${consumerId}-${selectedMaterial.MaterialId}-${formData?.ProductCode}`;
          setApplicationReference(appRef);

          // Create payment session request
          const paymentSessionRequest = {
            ApplicationReference: appRef,
            Amount: priceWithVat,
            Currency: selectedMaterial.Currency || 'TRY' // Default to TRY if no currency specified
          };

          const preSalesDto = {
            AssetId: AssetId || 0,
            ConsumerId: consumerId || 0,
            SKU: formData?.ProductCode,
            SerialNr: SerialParam,
            ParsedSerialNr: ParsedSerialNr,
            ProductionYear: ProductionYear,
            ProductionMonth: ProductionMonth,
            PaymentTypeId: paymentType,
            PaymentDetail: PaymentDetail,
            MaterialId: selectedMaterial.MaterialId,
            EmployeeId: SessionUser.TechnicianId,
            FileName: attachements?.name,
            MIMEType: attachements?.MIMEType,
            FileData: attachements?.FileData,
            WarrantyStartDate: garantiTarihi,
            Price: selectedMaterial?.Price,
            VatRate: selectedMaterial?.VatRate,
            VatId: selectedMaterial?.VatId,
            PriceListEntryId: selectedMaterial?.PricelistEntryId,
            CurrencyId: selectedMaterial?.CurrencyId,
            ConsumerAddressId: consumerAddressId || 0,
            BillingConsumerId: billingConsumer || 0,
            IsAssetInformationChange: AssetInformation
          };

          const warrantyPreSalesRequest = {
            createPaymentSessionRequestDto: paymentSessionRequest,
            salesDto: preSalesDto
          };

          // Join SignalR group for payment updates
          try {
            console.log('Attempting to join SignalR group:', appRef);
            await paymentSignalRService.joinGroup(appRef);
            console.log(`Successfully joined payment group: ${appRef}`);
          } catch (signalRError) {
            console.error('Failed to join SignalR group:', signalRError);
            // Continue with payment session creation even if SignalR fails
            // We'll show a warning to the user
            setPaymentError('Real-time updates may not work properly. Payment will still function.');
            setTimeout(() => setPaymentError(null), 5000); // Clear error after 5 seconds
          }

          // Create payment session
          dispatch(paymentThunks.WarrantyPreSales(warrantyPreSalesRequest))
            .then((response) => {
              if (response.payload && !response.payload.error) {
                if (response.payload.HasApplicationSingleProvider) {
                  //Payment session created but there is single provider so
                  //We wont open iframe but move to confirmation step
                  setSaving(false);
                  setPaymentCompleted(true);
                  setPaymentError(false);
                  setPaymentSuccessMessage('The payment link has been sent to the customer.');
                  setActiveStep(5);

                }
                else {
                  // Payment session created successfully
                  setSaving(false);
                  setPaymentUrl(response.payload.PaymentUrl);
                  setShowPaymentIframe(true);
                  setActiveStep(5); // Move to payment step
                }
              } else {
                // Handle payment session creation error
                setSaving(false);
                console.error('Payment session creation failed:', response.payload.error);
                setPaymentError('Payment session creation failed. Please try again.');
              }
            });

        } catch (error) {
          setSaving(false);
          console.error('Error creating payment session:', error);
          setPaymentError('An error occurred while creating payment session.');
        }
      }

    } else {
      setWorkCaseAndContract()
        .then(() => {
          setSaving(false);
          setPaymentCompleted(true);
          setPaymentError(false);
          setPaymentSuccessMessage('The payment created successfully.');
          setActiveStep(5);
        })
        .catch((error) => {
          setSaving(false);
          console.error('Error setting work case and contract:', error);
          setPaymentError('An error occurred while creating payment session.');
        });
    }
    };

    const handlePaymentCompleted = () => {
      setShowPaymentIframe(false);
      setWaitingForPayment(true);
      setPaymentError(null);
      // SignalR will handle the actual completion via ReceivePaymentUpdate

      // SironexPayments sayfasına yönlendirme ekle
      history.push('/SironexPayments');
    };

    const handlePaymentCancelled = async () => {
      setShowPaymentIframe(false);
      setWaitingForPayment(false);
      setPaymentError(null);
      setActiveStep(4); // Go back to confirmation step

      // Leave SignalR group
      if (applicationReference) {
        try {
          await paymentSignalRService.leaveGroup(applicationReference);
          setApplicationReference('');
        } catch (error) {
          console.error('Failed to leave SignalR group:', error);
        }
      }
    };

    const handleRetryPayment = () => {
      setPaymentError(null);
      setWaitingForPayment(false);
      setShowPaymentIframe(true);
    };

    const handleChangeBarcodeParse = Barcode => {

      setUyariCiktiNote(false);
      setAssetInformation(false);

      var Sku = SKU;
      var ProductYear = '';
      var ProductMonth = '';
      var SerialNr = '';

      if (SKU.length > 0) {
        Sku = SKU;
      }
      else {
        setUyariAciklamaNote(t('lblSKUWarning'));
        setUyariTipCiktiNote('error');
        setUyariCiktiNote(true);
        return
      }

      if (Barcode === '9900000199') {
        ProductYear = '1981';
        SerialNr = '1';
        ProductMonth = '1';
        setUyariAciklamaNote(Barcode + '-' + t('lblDummySerialNrWarning'));
        setUyariTipCiktiNote('error');
        setUyariCiktiNote(true);
        setProductMonth(ProductMonth);
        setProductYear(ProductYear);
        setProductionMonth(ProductMonth);
        setProductionYear(ProductYear);
        setSerialNumber(SerialNr);
        return
      }

      if (SessionUser.TenantId === 59) {
        ProductYear = '1981';
        SerialNr = Barcode;
        ProductMonth = '1';
        setUyariAciklamaNote(Barcode + '-' + t('lblDummySerialNrWarning'));
        setUyariTipCiktiNote('error');
        setUyariCiktiNote(true);
        setProductMonth(ProductMonth);
        setProductYear(ProductYear);
        setProductionMonth(ProductMonth);
        setProductionYear(ProductYear);
        setSerialNumber(SerialNr);
        return
      }
      setLoading3(true);

      axios
        .get(`/ParseSerialNumber/${ProductId}/${Barcode}`)
        .then(response => {
          if (response.data.Response == 1) {
            setSerialNumber(response.data.SerialNr);
            setProductMonth(response.data.MonthValue);
            setProductYear(response.data.YearValue);
            setProductionMonth(response.data.MonthValue);
            setProductionYear(response.data.YearValue);
            setParsedSerialNr(response.data.SerialNr);
            setSerialParam(Barcode);

            if (FirstSerialNumber != response.data.SerialNr || FirstMonth != response.data.MonthValue || FirstYear != response.data.YearValue) {
              setUyariAciklamaNote("Serial number information has changed. Asset information will change!");
              setUyariTipCiktiNote('warning');
              setUyariCiktiNote(true);
              setAssetInformation(true);
            }

            setLoading3(false);
            return;
          }

          axios
            .get(`/ControlSerialNumber/${Sku}/${0}/${Barcode}`)
            .then(response => {
              if (response.data) {
                var serialNumberYear = calculateSerialNumberYear(response.data.ProductionYearRule, Barcode)
                var serialNumberMonth = calculateSerialNumberMonth(response.data.ProductionMonthRule, Barcode)
                var wantedSerialNumber = findOriginalSerialNumber(response.data.SerialNumberRule, Barcode)

                if (serialNumberYear != null && serialNumberMonth != null && wantedSerialNumber != null) {
                  setProductionMonth(serialNumberMonth);
                  setProductionYear(serialNumberYear);
                  setProductMonth(serialNumberMonth);
                  setProductYear(serialNumberYear);
                  setSerialNumber(wantedSerialNumber);
                  setParsedSerialNr(wantedSerialNumber);
                  setLoading3(false);
                  return;
                }
              }
              else {
                if (Barcode.length === 10) {
                  ProductYear = '20' + Barcode.substring(0, 2);
                  SerialNr = Barcode.substring(2, 8);
                  ProductMonth = Barcode.substring(8, 10);
                  setProductMonth(ProductMonth);
                  setProductYear(ProductYear);
                  setProductionMonth(ProductMonth);
                  setProductionYear(ProductYear);
                  setSerialNumber(SerialNr);
                  setParsedSerialNr(SerialNr);
                  if (FirstSerialNumber != SerialNr || FirstMonth != ProductMonth || FirstYear != ProductYear) {
                    setUyariAciklamaNote("Serial number information has changed. A new asset will be created!");
                    setUyariTipCiktiNote('warning');
                    setUyariCiktiNote(true);
                    setAssetInformation(true);
                  }
                }
                if (Barcode.length === 14 || Barcode.length === 18) {
                  if (Barcode.length === 14) {
                    ProductYear = '202' + Barcode.substring(5, 6);
                    ProductMonth = Barcode.substring(6, 8);
                    SerialNr = Barcode.substring(8, 13);
                    setProductMonth(ProductMonth);
                    setProductYear(ProductYear);
                    setProductionMonth(ProductMonth);
                    setProductionYear(ProductYear);
                    setSerialNumber(SerialNr);
                    setParsedSerialNr(SerialNr);
                    if (FirstSerialNumber != SerialNr || FirstMonth != ProductMonth || FirstYear != ProductYear) {
                      setUyariAciklamaNote("Serial number information has changed. A new asset will be created!");
                      setUyariTipCiktiNote('warning');
                      setUyariCiktiNote(true);
                      setAssetInformation(true);
                    }
                  }
                  if (Barcode.length === 18) {
                    ProductYear = '20' + Barcode.substring(6, 8);
                    ProductMonth = Barcode.substring(14, 16);
                    SerialNr = Barcode.substring(9, 14);
                    setProductMonth(ProductMonth);
                    setProductYear(ProductYear);
                    setProductionMonth(ProductMonth);
                    setProductionYear(ProductYear);
                    setSerialNumber(SerialNr);
                    setParsedSerialNr(SerialNr);
                    if (FirstSerialNumber != SerialNr || FirstMonth != ProductMonth || FirstYear != ProductYear) {
                      setUyariAciklamaNote("Serial number information has changed. A new asset will be created!");
                      setUyariTipCiktiNote('warning');
                      setUyariCiktiNote(true);
                      setAssetInformation(true);
                    }
                  }
                }

                setSerialParam(Barcode);
                if (SessionUser.TenantId !== 78) {
                  if (
                    ProductYear === '' ||
                    ProductMonth === '' ||
                    SerialNr === '' ||
                    ProductYear === undefined ||
                    ProductMonth === undefined ||
                    SerialNr === undefined
                  ) {
                    setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
                    setUyariTipCiktiNote('error');
                    setUyariCiktiNote(true);
                    ProductYear = '';
                    SerialNr = '';
                    ProductMonth = '';
                    setProductMonth(ProductMonth);
                    setProductYear(ProductYear);
                    setProductionMonth(ProductMonth);
                    setProductionYear(ProductYear);
                    setSerialNumber(SerialNr);
                    setParsedSerialNr(SerialNr);
                  }
                  if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12) {
                    setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
                    setUyariTipCiktiNote('error');
                    setUyariCiktiNote(true);
                    ProductYear = '';
                    SerialNr = '';
                    ProductMonth = '';
                    setProductMonth(ProductMonth);
                    setProductYear(ProductYear);
                    setProductionMonth(ProductMonth);
                    setProductionYear(ProductYear);
                    setSerialNumber(SerialNr);
                  }
                  if (
                    ProductYear.length !== 4 ||
                    parseInt(ProductYear) > parseInt(moment().format('yyyy'))
                  ) {
                    setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
                    setUyariTipCiktiNote('error');
                    setUyariCiktiNote(true);
                    ProductYear = '';
                    SerialNr = '';
                    ProductMonth = '';
                    setProductMonth(ProductMonth);
                    setProductYear(ProductYear);
                    setProductionMonth(ProductMonth);
                    setProductionYear(ProductYear);
                    setSerialNumber(SerialNr);
                  }
                }
              }
              setLoading3(false);
            })
        })
        .catch(error => {
          setLoading3(false);
        });


      if (
        SessionUser.TenantId === 9
        || SessionUser.TenantId === 37
        || SessionUser.TenantId === 51
        || SessionUser.TenantId === 56
        || SessionUser.TenantId === 78
      ) {
        return;
      }
    };

    function calculateSerialNumberYear(yearRule, serialNumber) {
      if (yearRule == null || yearRule == undefined) {
        return null
      }
      else if (yearRule.includes(',')) {
        var tempYearRule = yearRule.split(',')
        var result = parseInt('20' + serialNumber[parseInt(tempYearRule[0]) - 1] + serialNumber[parseInt(tempYearRule[1]) - 1])
        return result
      }
      //CONSTANT
      else if (yearRule == '0') {
        var result = 1981
        return result
      }
      else {
        var year = parseInt(serialNumber[parseInt(yearRule) - 1])
        var currentYear = moment().format('yyyy')

        // Yıl Hesaplama için yılın son hanesini gelen yıl kuralının yılından çıkarıyorum
        // Eğer Kalan negatif ise mevcut yılın son hanesine 10 ekleyip yıl kuralından çıkarıp onu da Bütün yıldan çıkarıyorum 
        // örnek: 8 geldi 2'den çıkarıyorum çünkü 2022, 2 - 8 = -6
        // -6 sıfırdan küçük olduğu için 2ye 10 ekliyorum ve 12 - 8 yapıyorum sonucum 4
        // bu elimde ki 4 ise 2022 den çıkarıyorum sonuç 2018

        if (parseInt(currentYear.substring(3)) - year < 0) {
          var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) + 10 - year)
          return result
        }
        else {
          var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) - year)
          return result
        }
      }
    }

    function calculateSerialNumberMonth(monthRule, serialNumber) {
      if (monthRule == null || monthRule == undefined) {
        return null
      }
      else if (monthRule.includes(',')) {
        var tempMonthRule = monthRule.split(',')
        var result = parseInt(serialNumber[parseInt(tempMonthRule[0]) - 1] + serialNumber[parseInt(tempMonthRule[1]) - 1])
        if (parseInt(result) > 12) {
          setUyariAciklamaNote(serialNumber + '-' + t('lblInvalidSerialNr'));
          setUyariTipCiktiNote('error');
          setUyariCiktiNote(true);
          return null;
        }
        return result
      }
      else if (monthRule.length == 1 && monthRule != '0') {
        var tempResult = serialNumber[parseInt(monthRule) - 1]
        if (Number.isInteger(+tempResult)) {
          return tempResult
        }
        else if (tempResult == 'A') {
          return 10
        }
        else if (tempResult == 'B') {
          return 11
        }
        else if (tempResult == 'C') {
          return 12
        }
      }
      //CONSTANT
      else if (monthRule == '0') {
        var result = 1
        return result
      }
      else {
        return null
      }
    }

    function findOriginalSerialNumber(serialNumberRule, serialNumber) {
      if (serialNumberRule == null || serialNumberRule == undefined) {
        return null
      }
      else if (serialNumberRule.includes(',')) {
        var tempSerialNumberRule = serialNumberRule.split(',')
        if (parseInt(tempSerialNumberRule[1]) - serialNumber.length === 1) {
          var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
          return result
        }
        else if (serialNumber.length !== parseInt(tempSerialNumberRule[1])) {
          setUyariAciklamaNote(serialNumber + '-' + t('lblInvalidSerialNr'));
          setUyariTipCiktiNote('error');
          setUyariCiktiNote(true);
          return null;
        }
        else {
          var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
          return result
        }
      }
      else {
        return null
      }
    }

    const uyariKapatCiktiNote = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setUyariCiktiNote(false);
    };

    const GarantiTarihihandleChange = value => {
      let Deger = moment(value).format('YYYY-MM-DD');
      setGarantiTarihi(Deger);
    };

    return (
      <Container>
        {saved ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
            <CheckCircleOutlineIcon style={{ fontSize: 100, color: 'green' }} />
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="flex-start" height="100vh" mt={4}>
            <Box className={classes.box} width="600px" border={1} borderColor="grey.500" p={3} borderRadius={4} mt={4}>
              <Stepper activeStep={activeStep} className={classes.stepper}>
                {steps.map((label, index) => (
                  <Step key={label} completed={activeStep > index} className={activeStep === index ? classes.activeStep : ''} classes={{ completed: classes.completed }}>
                    <StepLabel classes={{ root: classes.step }}>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div className={classes.line}></div>
              {activeStep === 0 && (
                <Box className={classes.paper} mb={2} p={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <Box border={1} p={2} borderRadius={4}>
                        <Typography variant="h6" gutterBottom>
                          <PersonIcon style={{ marginRight: '8px', color: '#4caf50' }} /> {/* Person icon */}
                          Customer Information
                        </Typography>
                        <TextField name="firstName" label="Name" value={formData ? formData.ConsumerName : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="address" label="Address" value={formData ? formData.Address : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="phone" label="Telephone" value={formData ? formData.Phone : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="title" label="Region" value={formData ? formData.Region : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="lastName" label="City" value={formData ? formData.City : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="title" label="District" value={formData ? formData.District : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="taxid" label="Tax Id" value={formData ? formData.TaxId : ''} InputProps={{ readOnly: true }} fullWidth />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {activeStep === 1 && (
                <Box className={classes.paper} mb={2} p={2}>
                  <Typography variant="h6" className={classes.header}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell> {/* Add an empty cell for the checkbox */}
                          <TableCell>Material</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>VAT Rate</TableCell>
                          <TableCell>Price with VAT</TableCell>
                          <TableCell>Benefit</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {materials.map((material) => (
                          <TableRow
                            key={material.Materialcode}
                            selected={selectedMaterial === material}
                            onClick={() => handleMaterialSelect(material)}
                            className={selectedMaterial === material ? 'selected' : ''}
                          >
                            <TableCell>
                              <GreenCheckbox
                                checked={selectedMaterial === material}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMaterialSelect(material);
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <span style={{ fontWeight: 'bold' }}>{material.Materialcode}</span> {material.MaterialDescription}
                            </TableCell>
                            <TableCell>
                              <b>
                                <Chip
                                  size="small"
                                  label={`${moneyFormat(material.Price, SessionUser.TenantCode, material.Currency)} ${material.Currency
                                    }`}
                                />
                              </b>
                            </TableCell>
                            <TableCell>{material.VatRate}</TableCell>
                            <TableCell>
                              <b>
                                <Chip
                                  size="small"
                                  label={`${moneyFormat(material.PriceWithVat, SessionUser.TenantCode, material.Currency)} ${material.Currency
                                    }`}
                                />
                              </b>
                            </TableCell>
                            <TableCell>{material.Benefit}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Typography>
                </Box>
              )}
              {activeStep === 2 && (
                <Box className={classes.paper} mb={2} p={2}>
                  {uyariCiktiNote ? (
                    <Alert
                      onClose={uyariKapatCiktiNote}
                      open={uyariCiktiNote}
                      message={uyariAciklamaNote || ''}
                      variant={uyariTipCiktiNote}
                    />
                  ) : (
                    <div />
                  )}
                  {loading3 ? (
                    <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
                  ) : (
                    <div />
                  )}
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Box border={1} p={2} borderRadius={4}>
                        <Typography variant="h6" gutterBottom>
                          <LocalMallIcon style={{ marginRight: '8px', color: '#2196f3' }} /> {/* Ürün icon */}
                          Product Information
                        </Typography>
                        <TextField name="productionPeriod" label="Brand" value={formData ? formData.Brand : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="barcode" label="SKU" value={formData ? formData.ProductCode : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="modelCode" label="Product" value={formData ? formData.Product : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="productionYear" label="Production Year" value={formData ? ProductionYear : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="productionMonth" label="Production Month" value={formData ? ProductionMonth : ''} InputProps={{ readOnly: true }} fullWidth />
                        <TextField name="serialNumber" label="Serial Nr" value={formData ? ParsedSerialNr : ''} InputProps={{ readOnly: true }} fullWidth />
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box border={1} p={2} borderRadius={4}>
                        <div>
                          <div className={classes.wrapper}>
                            <Grid item xs={12} sm={12}>
                              <Grid item xs={12} sm={9} lg={9}>
                                <ThemeProvider theme={materialTheme}>
                                  <MuiPickersUtilsProvider
                                    utils={DateFnsUtils}
                                    locale={localeMap[locale]}
                                  >
                                    <KeyboardDatePicker
                                      margin="normal"
                                      color="primary"
                                      size="small"
                                      fullWidth
                                      inputVariant="outlined"
                                      id="GarantiTarihi"
                                      label={t('Fatura_Tarihi')}
                                      invalidDateMessage={t('hatali_tarih')}
                                      format="dd.MM.yyyy"
                                      variant="outlined"
                                      value={garantiTarihi}
                                      onChange={e => GarantiTarihihandleChange(e)}
                                      KeyboardButtonProps={{
                                        'aria-label': 'change date'
                                      }}
                                    />
                                  </MuiPickersUtilsProvider>
                                </ThemeProvider>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid item xs={10}>
                                  <TextField
                                    label={t('lblSerialNr')}
                                    name="Barcode"
                                    size="small"
                                    value={SerialParam || ''}
                                    fullWidth
                                    onChange={e => setSerialParam(e.target.value)}
                                    variant="outlined"
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <Button
                                    disableElevation
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => handleChangeBarcodeParse(SerialParam || '')}
                                  >
                                    <RepeatOneIcon />
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={4}>
                                  <TextField
                                    size="small"
                                    name="SerialNumber"
                                    error={SerialNumber.length > 0 ? false : Required}
                                    autoComplete="no"
                                    value={SerialNumber ? SerialNumber : ''}
                                    onChange={handleChange}
                                    fullWidth
                                    disabled
                                    label={t('lblSerialNumber')}
                                    variant="outlined"
                                    helperText={
                                      formState.filter(n => n.name === 'SerialNumber')[0].valid
                                        ? ''
                                        : formState.filter(n => n.name === 'SerialNumber')[0]
                                          .errorMessage
                                    }
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    size="small"
                                    name="ProductYear"
                                    error={ProductYear.toString().length > 0 ? false : Required}
                                    autoComplete="no"
                                    value={ProductYear ? ProductYear : ''}
                                    onChange={handleChange}
                                    fullWidth
                                    disabled
                                    label={t('lblProductYear')}
                                    variant="outlined"
                                    helperText={
                                      formState.filter(n => n.name === 'ProductYear')[0].valid
                                        ? ''
                                        : formState.filter(n => n.name === 'ProductYear')[0]
                                          .errorMessage
                                    }
                                  />
                                </Grid>
                                <Grid item xs={4}>
                                  <TextField
                                    size="small"
                                    name="ProductMonth"
                                    error={ProductMonth.toString().length > 0 ? false : Required}
                                    autoComplete="no"
                                    value={ProductMonth ? ProductMonth : ''}
                                    onChange={handleChange}
                                    fullWidth
                                    disabled
                                    label={t('lblProductMonth')}
                                    variant="outlined"
                                    helperText={
                                      formState.filter(n => n.name === 'ProductMonth')[0].valid
                                        ? ''
                                        : formState.filter(n => n.name === 'ProductMonth')[0]
                                          .errorMessage
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {activeStep === 3 && (
                <Box className={classes.paper} mb={2} p={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <FormControl variant="outlined" fullWidth>
                        <TextField
                          size="small"
                          select
                          label={t('Payment Type')}
                          onChange={handleChangePaymentType}
                          value={paymentType}
                          variant="outlined"
                          fullWidth
                        >
                          {activePaymentTypeData &&
                            activePaymentTypeData.map((p) => (
                              <MenuItem key={p.Id} value={p.Id}>
                                {p.Dsc}
                              </MenuItem>
                            ))}
                        </TextField>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t('Payment Detail')}
                        name="PaymentDetail"
                        multiline
                        size="small"
                        fullWidth
                        value={PaymentDetail}
                        onChange={handleChangePaymentDetail}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Box display="flex" alignItems="center" mt={2}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={attachements.name ? attachements.name : 'Upload the relevant receipt...'}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <Button
                      variant="contained"
                      component="label"
                      style={{ backgroundColor: '#388e3c', color: 'white', marginLeft: '8px' }} // Dark green button
                    >
                      UPLOAD
                      <input
                        type="file"
                        hidden
                        onChange={(e) => handleChangeImage(e)}
                      />
                    </Button>
                  </Box>

                  {/* Ship to and Bill to Checkbox */}
                  <Box mt={2}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={sameAddress}
                          onChange={() => setSameAddress(!sameAddress)}
                          color="primary"
                        />
                      }
                      label={t('Ship to and Bill to same address')}
                    />
                  </Box>
                  <div>

                    {/* Eğer checkbox seçili değilse, CardContent içerisinde yeni alan gösterilir */}
                    {!sameAddress && (
                      <Grid container spacing={2} mt={2}>
                        <Grid item xs={12}>
                          <Tooltip title={t('Please enter phone number to search!')} arrow>
                            <Autocomplete
                              id="asynchronous-demo"
                              open={open}
                              value={billingConsumer}
                              onOpen={() => {
                                setOpen(true);
                              }}
                              onClose={() => {
                                setOpen(false);
                              }}
                              options={optionsBillingConsumer}
                              getOptionLabel={(option) => option.Dsc}
                              loading={loading}
                              onChange={(event, newInputValue) => {
                                if (newInputValue && newInputValue.Dsc) {
                                  updateText(newInputValue);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  size="small"
                                  onChange={(e) => setSearchBillingConsumer(e.target.value)}
                                  variant="outlined"
                                  label={t('Search Billing')}
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {loading ? (
                                          <CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    )}

                    <Box mt={4} />

                    <Backdrop className={classes.backdrop} open={loading2}>
                      <CircularProgress color="inherit" />
                    </Backdrop>

                    {/* CardContent ile adresleri gösterin */}
                    {!sameAddress && (
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell style={{ padding: '0px 16px' }}></TableCell> {/* Reduced padding */}
                              <TableCell style={{ padding: '0px 16px' }}>Addresses</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {consumerAddressDetails.map((address) => (
                              <TableRow
                                key={address.ConsumerAddressId}
                                onClick={() => handleAddressSelect(address)}
                                style={{
                                  cursor: 'pointer',
                                  backgroundColor: consumerAddressId === address.ConsumerAddressId ? '#f0f8ff' : 'white',
                                }}
                                hover
                              >
                                <TableCell style={{ padding: '0px 16px' }}>
                                  <Radio
                                    checked={consumerAddressId === address.ConsumerAddressId}
                                    onChange={() => handleAddressSelect(address.ConsumerAddressId)}
                                    value={address.ConsumerAddressId}
                                    color="primary"
                                  />
                                </TableCell>
                                <TableCell style={{ padding: '0px 16px' }}>{address.Dsc}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </div>
                </Box>
              )}
              {activeStep === 4 && (
                <Box className={classes.paper} mb={2} p={2}>
                  <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} md={6}>
                      <Box border={1} p={2} borderRadius={4}>
                        <Typography variant="h6" gutterBottom align="center">Order and Payment Confirmation</Typography>
                        <TextField
                          label="Name"
                          value={formData?.ConsumerName}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="Address"
                          value={formData?.Address}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="Brand"
                          value={formData?.Brand}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="SKU"
                          value={formData?.ProductCode}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="Product"
                          value={formData?.Product}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="Selected Material"
                          value={selectedMaterial?.MaterialDescription}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="Material Price"
                          InputProps={{
                            readOnly: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <Box display="flex" alignItems="center">
                                  {selectedMaterial?.Price}
                                  <Box ml={1}>
                                    {selectedMaterial?.Currency}
                                  </Box>
                                </Box>
                              </InputAdornment>
                            ),
                          }}
                          fullWidth
                          margin="normal"
                        />
                        <TextField
                          label="Barcode"
                          value={`${SKU || ''}${SerialParam || ''}`}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          margin="normal"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Box mt={4} display="flex" justifyContent="center">
                    <Card variant="outlined" style={{ padding: '16px', backgroundColor: '#f9f9f9', borderColor: '#4caf50' }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isConfirmed}
                            onChange={(e) => setIsConfirmed(e.target.checked)}
                            color="primary"
                          />
                        }
                        label={
                          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                            I confirm the above information and agree to proceed with the purchase.
                          </Typography>
                        }
                      />
                    </Card>
                  </Box>
                  {SessionUser.TenantId === 82 ||SessionUser.TenantId === 37 && (
                    <Box mt={2} display="flex" justifyContent="center">
                      <Typography variant="body2" align="center">
                        By proceeding, you agree to the
                        <Link
                          href="https://www.hitachi-homeappliances.com.hk/en/customer_service/warranty_service/terms_and_conditions_of_maintenance_scheme/index.html"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ marginLeft: 4 }}
                        >
                          Terms and Conditions
                        </Link>
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
              {activeStep === 5 && (
                <Box className={classes.paper} mb={2} p={2}>
                  {/* Connection State Indicator */}
                  <Box mb={1} display="flex" alignItems="center" justifyContent="center">
                    <Typography variant="caption" color={connectionState === 'connected' ? 'primary' : 'error'}>
                      SignalR Status: {connectionState}
                    </Typography>
                  </Box>
                  {/* Connection State Indicator */}
                  <Box mb={1} display="flex" alignItems="center" justifyContent="center">
                    <Typography variant="caption" color={connectionState === 'connected' ? 'primary' : 'error'}>
                      SignalR Status: {connectionState}
                    </Typography>
                  </Box>

                  {paymentError ? (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px">
                      <Typography variant="h6" gutterBottom align="center" color="error">
                        Payment Error
                      </Typography>
                      <Typography variant="body1" align="center" color="error" style={{ marginBottom: 16 }}>
                        {paymentError}
                      </Typography>
                      <Box>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleRetryPayment}
                          style={{ marginRight: 8 }}
                        >
                          Retry Payment
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={handlePaymentCancelled}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  ) : paymentCompleted ? (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px">
                      <CheckCircleOutlineIcon style={{ fontSize: 80, color: 'green', marginBottom: 16 }} />
                      <Typography variant="h6" gutterBottom align="center" color="primary">
                        Payment Operation Completed Successfully!
                      </Typography>
                      <Typography variant="body1" align="center" color="textSecondary">
                        {paymentSuccessMessage}
                      </Typography>
                    </Box>
                  ) : showPaymentIframe && paymentUrl ? (
                    <Box>
                      <Typography variant="h6" gutterBottom align="center">
                        Complete Your Payment
                      </Typography>
                      <Box display="flex" justifyContent="center" mb={2}>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handlePaymentCancelled}
                          size="small"
                        >
                          Cancel Payment
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handlePaymentCompleted}
                          size="small"
                          style={{ marginLeft: 8 }}
                        >
                          Payment Completed
                        </Button>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        className={classes.paymentContainer}
                      >
                        <iframe
                          src={paymentUrl}
                          className={classes.paymentIframe}
                          frameBorder="0"
                          title="Payment"
                        />
                      </Box>
                    </Box>
                  ) : waitingForPayment ? (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px">
                      <CircularProgress size={60} style={{ marginBottom: 16 }} />
                      <Typography variant="h6" gutterBottom align="center">
                        Payment Processing...
                      </Typography>
                      <Typography variant="body1" align="center" color="textSecondary">
                        Please wait while we process your payment.
                      </Typography>
                      <Typography variant="caption" align="center" color="textSecondary" style={{ marginTop: 8 }}>
                        You will be automatically redirected upon completion.
                      </Typography>
                      <Box mt={2}>
                        <Button
                          variant="outlined"
                          onClick={handlePaymentCancelled}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="400px">
                      <Typography variant="h6" gutterBottom align="center">
                        Preparing Payment...
                      </Typography>
                      <CircularProgress />
                    </Box>
                  )}
                </Box>
              )}
              <Grid container justifyContent="center" style={{ marginTop: '16px' }}>
                {activeStep !== 0 && activeStep !== 5 && (
                  <Grid item xs={6} style={{ textAlign: 'left' }}>
                    <Button variant="contained" onClick={handleBack} startIcon={<ArrowBackIcon />}>
                      Back
                    </Button>
                  </Grid>
                )}
                {activeStep !== 5 && (
                  <Grid item xs={6} style={{ textAlign: 'right' }}>
                    {activeStep !== steps.length - 2 ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        endIcon={<ArrowForwardIcon />}
                        disabled={(activeStep === 1 && !selectedMaterial) || (activeStep === 2 && !ProductYear)} // Disable "Next" button if no material is selected in step 1
                      >
                        Next
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                        disabled={!isConfirmed || saving}
                        startIcon={saving && <CircularProgress size={20} />}
                      >
                        {saving ? 'Creating Payment Session...' : 'Proceed to Payment'}
                      </Button>
                    )}
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
        )}
      </Container>
    );
  };

  export default connect(state => ({
    tasks: state.tasks1,
  }), {
    getTasksRequest,
  })(FormPage);